
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import HeroSection from './components/HeroSection';
import ScriptureBanner from './components/ScriptureBanner';
import WelcomeSection from './components/WelcomeSection';
import FeaturedBooks from './components/FeaturedBooks';
import DevotionsSection from './components/DevotionsSection';
import ContactSection from './components/ContactSection';

const HomePage = () => {
  return (
    <div className="min-h-screen bg-[#FDFBF7]">
      <Navbar />
      <HeroSection />
      <ScriptureBanner />
      <WelcomeSection />
      <FeaturedBooks />
      <DevotionsSection />
      <ContactSection />
      <Footer />
    </div>
  );
};

export default HomePage;
